import { render, staticRenderFns } from "./RecruiterReferral.vue?vue&type=template&id=606c4b7c&"
import script from "./RecruiterReferral.vue?vue&type=script&lang=js&"
export * from "./RecruiterReferral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports